import { Brand } from '@blade/std-lib'

export const TelegramAuthTokenTypeId = 'tradebot-tma/TelegramAuthToken'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TelegramAuthTokenTypeId = typeof TelegramAuthTokenTypeId

export type TelegramAuthToken = Brand.Branded<string, TelegramAuthTokenTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TelegramAuthToken = Brand.nominal<TelegramAuthToken>()
